(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
